module.exports = __webpack_public_path__ + "img/sushitatarmircooverviewlachs.8f33d6a5.jpg";